import { render, staticRenderFns } from "./SfBadge.vue?vue&type=template&id=1cdb8da7&"
import script from "./SfBadge.vue?vue&type=script&lang=js&"
export * from "./SfBadge.vue?vue&type=script&lang=js&"
import style0 from "./SfBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports